import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" {...props}><path fill="none" stroke="#b2354a" strokeWidth="16" strokeLinecap="round" d="M89 9a81 81 0 102 0zm1 38v58m0 25v1" /></svg>);